import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {
  FormControl,
  IconButton,
  NativeSelect,
  Pagination,
  Stack,
  TablePagination,
  TableSortLabel,
  Box,
} from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

interface Props {
  tableHeadings: { [key: string]: string };
  rows: any[];
}

const ImportedObjectsTable = ({ tableHeadings, rows }: Props) => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const headCells = Object.entries(tableHeadings);

  const handleChangePage = (_: any, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  //   const [openModal, setOpenModal] = React.useState(false);

  //   const handleOpenModal = () => {
  //     setOpenModal(true);
  //   };

  //   const handleCloseModal = () => {
  //     setOpenModal(false);
  //   };

  return (
    <>
      <TableContainer className="">
        <Table size="small" stickyHeader sx={{ whiteSpace: "nowrap" }}>
          <TableHead>
            <TableRow>
              {headCells.map(([_, value], index) => {
                const isLast = index === headCells.length - 1;

                return (
                  <TableCell key={index} align={isLast ? "center" : "left"}>
                    <TableSortLabel>
                      {value && typeof value === "string" ? value : ""}
                    </TableSortLabel>
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => (
                <React.Fragment key={row.cron_id}>
                  <TableRow
                    sx={{
                      "& > *": {
                        borderBottom:
                          "1px solid rgba(224, 224, 224, 1) !important",
                      },
                    }}
                  >
                    {headCells.map(([key], cellIndex) => (
                      <TableCell key={cellIndex} align="left">
                        {key === "object_level" ? (
                          <>
                            <FormControl fullWidth>
                              <NativeSelect
                                disableUnderline
                                defaultValue={30}
                                inputProps={{
                                  name: "",
                                }}
                              >
                                <option value={10}>
                                  {row[key] ? row[key] : "N/A"}
                                </option>
                                <option value={20}>
                                  {row[key] ? row[key] : "N/A"}
                                </option>
                                <option value={30}>
                                  {row[key] ? row[key] : "N/A"}
                                </option>
                              </NativeSelect>
                            </FormControl>
                          </>
                        ) : key === "field_name" ? (
                          <>{row[key] ? row[key] : "N/A"}</>
                        ) : key === "field_value" ? (
                          <>{row[key] ? row[key] : "N/A"}</>
                        ) : key === "remove_object" ? (
                          <>
                            <Box textAlign="center">
                              <IconButton size="small" color="error">
                                <CloseOutlinedIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          </>
                        ) : row[key] ? (
                          row[key]
                        ) : (
                          "N/A"
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                </React.Fragment>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Stack
        spacing={1}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ display: "none" }}
      >
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={rows?.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          classes={{
            displayedRows: "hidden-displayed-rows", // Apply the custom class
          }}
          sx={{
            ".MuiTablePagination-actions": {
              display: "none",
            },
            ".MuiTablePagination-input": {
              marginLeft: "15px",
            },
            ".MuiTablePagination-toolbar": {
              paddingLeft: "16px",
            },
          }}
        />
        <Pagination
          count={Math.ceil(rows?.length / rowsPerPage)}
          page={page + 1}
          showFirstButton
          showLastButton
          className="pagination-button"
          color="secondary"
          size="small"
          sx={{
            ".css-wjh20t-MuiPagination-ul": {
              justifyContent: "center",
            },
          }}
          onChange={(_, value) => handleChangePage(null, value - 1)}
        />
        <TablePagination
          rowsPerPageOptions={[]}
          component="div"
          count={rows?.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            ".css-16c50h-MuiInputBase-root-MuiTablePagination-select,.MuiTablePagination-selectLabel":
              {
                display: "none",
              },
            ".MuiTablePagination-actions": {
              display: "none",
            },
            ".MuiTablePagination-toolbar": {
              paddingRight: "16px",
            },
          }}
        />
      </Stack>
    </>
  );
};

export default ImportedObjectsTable;
